import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>
            POST /users/{"{"}userId{"}"}/colleaguesbulk
          </h1>
        </div>
        <p>
          Return a JSON object that lists the users that are a part of the same
          company as the user specified by{" "}
          <em>
            {"{"}userId{"}"}
          </em>
          .
        </p>
        <ul>
          <li>
            Maximum of 50 emails in request, 51st and greater emails in request
            are ignored.
          </li>
          <li>Only user object of found emails are included in response.</li>
          <li>All emails are queried not just primary email.</li>
          <li>Collegues are automatically added by email</li>
        </ul>
        <p />
        <h2>URL Parameters</h2>
        <p>None.</p>
        <h2>Body Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td />
                <td>Array of email strings (Max: 50).</td>
                <td>array of strings</td>
                <td>Yes</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/api/users/me/colleaguesbulk
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h4>Body</h4>
        <pre className="json">
          [{"\n"}
          {"    "}"user1@fakecompany.com",{"\n"}
          {"    "}"user2@fakecompany.com",{"\n"}
          {"    "}"user3@fakecompany.com",{"\n"}
          {"    "}"user4@fakecompany.com",{"\n"}
          {"    "}"user5@fakecompany.com",{"\n"}
          {"    "}"user6@fakecompany.com" //does not exist{"\n"}]
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
          {"{"}
          {"\n"}
          {"    "}"data": [{"\n"}
          {"        "}
          {"{"}
          {"\n"}
          {"            "}"_id": "585988477b40f9a576053aa3",{"\n"}
          {"            "}"displayname": "John Smith1",{"\n"}
          {"            "}"picturefile":
          "pictures/pfpic_juser1_977ffaaf-6b90-4e08-acde-06c66955bef1",{"\n"}
          {"            "}"emails": [{"\n"}
          {"                "}
          {"{"}
          {"\n"}
          {"                    "}"primary": true,{"\n"}
          {"                    "}"value": "user1@fakecompany.com"{"\n"}
          {"                "}
          {"}"}
          {"\n"}
          {"            "}],{"\n"}
          {"            "}"phone_numbers": [],{"\n"}
          {"            "}"name": {"{"}
          {"\n"}
          {"                "}"pronunciation_url": "",{"\n"}
          {"                "}"pronunciation": "",{"\n"}
          {"                "}"middlename": "",{"\n"}
          {"                "}"honorific_suffix": "",{"\n"}
          {"                "}"honorific_prefix": "",{"\n"}
          {"                "}"givenname": "John",{"\n"}
          {"                "}"formatted": "",{"\n"}
          {"                "}"familyname": "User1"{"\n"}
          {"            "}
          {"}"},{"\n"}
          {"            "}"username": "user1@fakecompany.com",{"\n"}
          {"            "}"accountId":
          "ag9zfm9uZXNuYXRlc3RpbmdyEQsSBFVzZXIYgIFAqMHf1AgJ",{"  "}//userId from
          Avaya Cloud Accounts{"\n"}
          {"            "}"picture_url":
          "https://storage.googleapis.com/onesnatesting/pictures/pfpic_juser1_977ffaaf-6b90-4e08-acde-06c66955bef1"
          {"\n"}
          {"        "}
          {"}"},{"\n"}
          {"        "}
          {"{"}
          {"\n"}
          {"            "}"_id": "5898a16e7b40f9a576054f91",{"\n"}
          {"            "}"displayname": "John User2",{"\n"}
          {"            "}"picturefile":
          "pictures/pfpic_juser2_977ffaaf-6b90-4e08-acde-06c66955bef2",{"\n"}
          {"            "}"emails": [{"\n"}
          {"                "}
          {"{"}
          {"\n"}
          {"                    "}"primary": true,{"\n"}
          {"                    "}"value": "user2@fakecompany.com"{"\n"}
          {"                "}
          {"}"},{"\n"}
          {"                "}
          {"{"}
          {"\n"}
          {"                    "}"primary": false,{"\n"}
          {"                    "}"value": "user3@fakecompany.com"{"\n"}
          {"                "}
          {"}"}
          {"\n"}
          {"            "}],{"\n"}
          {"            "}"phone_numbers": [{"\n"}
          {"                "}
          {"{"}
          {"\n"}
          {"                "}"verified": false,{"\n"}
          {"                "}"primary": true,{"\n"}
          {"                "}"canonicalForm": "+19055551234",{"\n"}
          {"                "}"type": "mobile",{"\n"}
          {"                "}"value": "+19055551234"{"\n"}
          {"                "}
          {"}"}
          {"\n"}
          {"            "}],{"\n"}
          {"            "}"name": {"{"}
          {"\n"}
          {"                "}"pronunciation_url": "",{"\n"}
          {"                "}"pronunciation": "",{"\n"}
          {"                "}"middlename": "",{"\n"}
          {"                "}"honorific_suffix": "",{"\n"}
          {"                "}"honorific_prefix": "",{"\n"}
          {"                "}"givenname": "John",{"\n"}
          {"                "}"formatted": "",{"\n"}
          {"                "}"familyname": "User2"{"\n"}
          {"            "}
          {"}"},{"\n"}
          {"            "}"username": "user2@fakecompany.com",{"\n"}
          {"            "}"accountId":
          "ag9zfm9uZXNuYXRlc3RpbmdyEQsSBFVzZXIYgICAqMhf1AgJ",{"  "}//userId from
          Avaya Cloud Accounts{"\n"}
          {"            "}"picture_url":
          "https://storage.googleapis.com/onesnatesting/pictures/pfpic_juser2_977ffaaf-6b90-4e08-acde-06c66955bef2"
          {"\n"}
          {"        "}
          {"}"},{"\n"}
          {"        "}
          {"{"}
          {"\n"}
          {"            "}"_id": "593989c06f0e166d93fab8a2",{"\n"}
          {"            "}"username": "user4@fakecompany.com",{"\n"}
          {"            "}"name": {"{"}
          {"\n"}
          {"                "}"pronunciation_url": "",{"\n"}
          {"                "}"pronunciation": "",{"\n"}
          {"                "}"middlename": "",{"\n"}
          {"                "}"honorific_suffix": "",{"\n"}
          {"                "}"honorific_prefix": "",{"\n"}
          {"                "}"givenname": "John",{"\n"}
          {"                "}"formatted": "",{"\n"}
          {"                "}"familyname": "User4"{"\n"}
          {"            "}
          {"}"},{"\n"}
          {"            "}"emails": [{"\n"}
          {"                "}
          {"{"}
          {"\n"}
          {"                    "}"primary": true,{"\n"}
          {"                    "}"value": "user4@fakecompany.com"{"\n"}
          {"                "}
          {"}"},{"\n"}
          {"                "}
          {"{"}
          {"\n"}
          {"                    "}"primary": false,{"\n"}
          {"                    "}"value": "user5@fakecompany.com"{"\n"}
          {"                "}
          {"}"}
          {"\n"}
          {"            "}],{"\n"}
          {"            "}"phone_numbers": [{"\n"}
          {"                "}
          {"{"}
          {"\n"}
          {"                "}"verified": false,{"\n"}
          {"                "}"primary": true,{"\n"}
          {"                "}"canonicalForm": "+19055551234",{"\n"}
          {"                "}"type": "mobile",{"\n"}
          {"                "}"value": "+19055551234"{"\n"}
          {"                "}
          {"}"}
          {"\n"}
          {"            "}],{"\n"}
          {"            "}"picturefile":
          "pictures/pfpic_juser4_026498e4-e761-4acf-9a09-5b37ac7ed071",{"\n"}
          {"            "}"displayname": "John User4",{"\n"}
          {"            "}"accountId":
          "ag9zfm9uZXNuYXRlc3RpbmdyEQsSBFVzZXIYgICAqMHf1AhJ",{"  "}//userId from
          Avaya Cloud Accounts{"\n"}
          {"            "}"picture_url":
          "https://storage.googleapis.com/onesnatesting/pictures/pfpic_juser4_026498e4-e761-4acf-9a09-5b37ac7ed071"
          {"\n"}
          {"        "}
          {"}"}
          {"\n"}
          {"    "}],{"\n"}
          {"    "}"total": 3{"\n"}
          {"}"}
        </pre>
      </div>
    </div>
  </Layout>
)
